export const CHART_HEIGHT = 220;
